import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Context } from '../components/Store';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation().pathname;
  const [state] = useContext(Context);
  const isTechnicien = state.user?.status === 1;
  const switchMenu = () => {
    isMenuOpen ? setIsMenuOpen(false) : setIsMenuOpen(true);
  };

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <nav className="bg-stbMain">
      <div className="mx-auto px-2 sm:px-6 lg:px-8">
        <div className="relative flex items-center justify-between h-16">
          <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
            <button
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-900 focus:ring-white"
              aria-expanded="false"
              onClick={switchMenu}
            >
              <span className="sr-only">Open main menu</span>
              <svg
                className={`${isMenuOpen ? 'hidden' : 'block'} h-6 w-6`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              <svg
                className={`${isMenuOpen ? 'block' : 'hidden'} h-6 w-6`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>
          <div className="flex-1 flex items-center sm:items-stretch sm:justify-start">
            <div className="hidden sm:block text-white whitespace-nowrap self-center ml-3 font-extrabold uppercase">
              <Link to="/" className="outline-none">
                STB
              </Link>
            </div>
            <div className="hidden sm:block sm:ml-6">
              <div className="flex space-x-4">
                <Link
                  to="/"
                  className={`${
                    location === '/fiches' ||
                    location === '/' ||
                    location.includes('/fiche/') ||
                    location.includes('/fiches')
                      ? 'bg-gray-900 text-white'
                      : 'text-gray-300 hover:bg-gray-900 hover:text-white'
                  } px-3 py-2 rounded-md text-sm font-medium"`}
                >
                  <span className="whitespace-nowrap">Fiches</span>
                </Link>
                {!isTechnicien && (
                  <Link
                    to="/clients"
                    className={`${
                      location === '/clients' ||
                      location.includes('/client/') ||
                      location.includes('/clients')
                        ? 'bg-gray-900 text-white'
                        : 'text-gray-300 hover:bg-gray-900 hover:text-white'
                    } px-3 py-2 rounded-md text-sm font-medium"`}
                  >
                    <span className="whitespace-nowrap">Clients</span>
                  </Link>
                )}
                {!isTechnicien && (
                  <Link
                    to="/gestion"
                    className={`${
                      location.includes('/gestion') ||
                      location.includes('/users') ||
                      location.includes('/vehicle')
                        ? 'bg-gray-900 text-white'
                        : 'text-gray-300 hover:bg-gray-900 hover:text-white'
                    } px-3 py-2 rounded-md text-sm font-medium"`}
                  >
                    <span className="whitespace-nowrap hidden md:block">
                      Gestion utilisateurs et véhicules
                    </span>
                    <span className="block md:hidden">Gestion</span>
                  </Link>
                )}
                {!isTechnicien && (
                  <Link
                    to="/stockages"
                    className={`${
                      location.includes('/stockages')
                        ? 'bg-gray-900 text-white'
                        : 'text-gray-300 hover:bg-gray-900 hover:text-white'
                    } px-3 py-2 rounded-md text-sm font-medium"`}
                  >
                    <span className="whitespace-nowrap">Zones de stockage</span>
                  </Link>
                )}
                {!isTechnicien && (
                  <Link
                    to="/pointages"
                    className={`${
                      location === '/pointages' ||
                      location.includes('/pointages/')
                        ? 'bg-gray-900 text-white'
                        : 'text-gray-300 hover:bg-gray-900 hover:text-white'
                    } px-3 py-2 rounded-md text-sm font-medium"`}
                  >
                    <span className="whitespace-nowrap">Pointages</span>
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div className="absolute inset-y-0 right-0 flex items-center pr-2 lg:static lg:inset-auto lg:ml-6 lg:pr-0 hidden lg:flex">
            <Link
              to="/logout"
              className={`${
                location === '/logout'
                  ? 'bg-gray-900 text-white'
                  : 'text-gray-300 hover:bg-gray-900 hover:text-white'
              } px-3 py-2 rounded-md text-sm font-medium"`}
            >
              Déconnexion
            </Link>
          </div>
        </div>
      </div>
      <div className={`${isMenuOpen ? 'block' : 'hidden'} sm:hidden`}>
        <div className="px-2 pt-2 pb-3 space-y-1">
          <div className="h-8">
            <Link
              to="/"
              className={`${
                location === '/fiches' ||
                location === '/' ||
                location.includes('/fiche/') ||
                location.includes('/fiches')
                  ? 'bg-gray-900 text-white'
                  : 'text-gray-300 hover:bg-gray-900 hover:text-white'
              } px-3 py-2 rounded-md text-sm font-medium"`}
            >
              Fiches
            </Link>
          </div>
          {!isTechnicien && (
            <div className="h-8">
              <Link
                to="/clients"
                className={`${
                  location === '/clients' ||
                  location.includes('/client/') ||
                  location.includes('/clients')
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-300 hover:bg-gray-900 hover:text-white'
                } px-3 py-2 rounded-md text-sm font-medium"`}
              >
                Clients
              </Link>
            </div>
          )}
          {!isTechnicien && (
            <div className="h-8">
              <Link
                to="/gestion"
                className={`${
                  location === '/gestion'
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-300 hover:bg-gray-900 hover:text-white'
                } px-3 py-2 rounded-md text-sm font-medium"`}
              >
                Gestion utilisateurs et véhicules
              </Link>
            </div>
          )}
          {!isTechnicien && (
            <div className="h-8">
              <Link
                to="/stockages"
                className={`${
                  location.includes('/stockages')
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-300 hover:bg-gray-900 hover:text-white'
                } px-3 py-2 rounded-md text-sm font-medium"`}
              >
                Zones de stockage
              </Link>
            </div>
          )}
          <div className="h-12">
            {!isTechnicien && (
              <Link
                to="/pointages"
                className={`${
                  location === '/pointages' || location.includes('/pointages/')
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-300 hover:bg-gray-900 hover:text-white'
                } px-3 py-2 rounded-md text-sm font-medium"`}
              >
                Pointages
              </Link>
            )}
          </div>
          <div className="h-8">
            <Link
              to="/logout"
              className="bg-gradient-to-r from-blue-500 to-blue-700 text-white hover:from-red-700 hover:to-red-900 px-3 py-2 rounded-md text-sm font-medium nav-link"
            >
              Déconnexion
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
